import { client as backendClient } from '@/modules/api/backend/client.gen';
import { client as geocoderClient } from '@/modules/api/geocoder/client.gen';

backendClient.setConfig({
  credentials: 'include',
});

geocoderClient.setConfig({ baseUrl: '/api/pelias' });
